import * as types from '../../actionTypes'
import { addUserToLicense } from '../../../lib/util'

const intitialState = {
  criteria: {},
  error: null,
  isLoading: false,
  isSaving: false,
  license: null,
  licenses: new Map(),
  notFound: false,
  userLicenses: null,
}

export default (state = intitialState, action) => {
  switch (action.type) {
    case types.CLEAR_LICENSES: {
      return {
        ...state,
        criteria: {},
        error: null,
        isLoading: false,
        license: null,
        licenses: new Map(),
        notFound: false,
        userLicenses: null,
      }
    }
    case types.FETCHING_LICENSES: {
      return {
        ...state,
        error: null,
        isLoading: true,
        notFound: false,
      }
    }
    case types.FETCHING_LICENSES_ERROR: {
      return {
        ...state,
        error: action.error,
        isLoading: false,
      }
    }
    case types.FETCHING_LICENSES_NOT_FOUND: {
      return {
        ...state,
        isLoading: false,
        notFound: true,
        licenses: new Map(),
      }
    }
    case types.FETCHING_LICENSES_SUCCESS: {
      const mapItems = action.licenses.map(i => {
        const licenseId = i.id ? i.id.toString() : ''
        return [licenseId, i]
      })
      return {
        ...state,
        isLoading: false,
        error: null,
        licenses: new Map(mapItems),
      }
    }
    case types.FETCHING_LICENSE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        license: action.license,
      }
    }
    case types.FETCHING_SUBSCRIPTION_FOR_LICENSES: {
      return {
        ...state,
        subscription: action.subscription,
      }
    }

    case types.FETCHING_USER_LICENSES:
    case types.FETCHING_USER_LICENSES_SUCCESS:
    case types.FETCHING_USER_LICENSES_ERROR: {
      return {
        ...state,
        isLoading: action.type === types.FETCHING_USER_LICENSES,
        error:
          action.type === types.FETCHING_USER_LICENSES_ERROR
            ? action.error
            : null,
        userLicenses:
          action.type === types.FETCHING_USER_LICENSES_SUCCESS
            ? action.licenses
            : null,
      }
    }

    case types.SAVING_LICENSE: {
      return {
        ...state,
        isSaving: true,
      }
    }
    case types.SAVING_LICENSE_SUCCESS: {
      return {
        ...state,
        license: action.license,
        isSaving: false,
      }
    }
    case types.SAVING_LICENSE_ERROR: {
      return {
        ...state,
        error: action.error,
        isSaving: false,
      }
    }
    case types.SET_LICENSE_SEARCH_QUERY: {
      return {
        ...state,
        criteria: action.criteria,
      }
    }
    case types.SENDING_LICENSE_USER: {
      return {
        ...state,
        error: null,
        isUpdating: true,
      }
    }

    case types.SENDING_LICENSE_USER_ERROR: {
      return {
        ...state,
        error: action.error,
        isUpdating: false,
      }
    }

    case types.SENDING_LICENSE_USER_SUCCESS: {
      const license = { ...state.license }

      if (action.licenseUserPayload)
        addUserToLicense(license, action.licenseUserPayload)
      return {
        ...state,
        license,
        error: null,
        isUpdating: false,
      }
    }
    case types.SENDING_LICENSE_USER_BULK: {
      return {
        ...state,
        error: null,
        isUpdating: true,
      }
    }
    case types.SENDING_LICENSE_USER_BULK_ERROR: {
      return {
        ...state,
        error: action.error,
        isUpdating: false,
        isBulkOperationCompleted: true,
        bulkOperationResult: [],
      }
    }

    case types.SENDING_LICENSE_USER_BULK_SUCCESS: {
      const license = { ...state.license }
      const newUsers = action.results.newUsers
      newUsers.forEach(user => addUserToLicense(license, user))

      return {
        ...state,
        license,
        error: null,
        isUpdating: false,
        isBulkOperationCompleted: true,
        bulkOperationResult: action.results,
      }
    }

    case types.RESET_BULK_ADD_USERS: {
      return {
        ...state,
        isBulkOperationCompleted: false,
        bulkOperationResult: [],
        error: null,
      }
    }

    case types.DELETING_LICENSE_USER: {
      return {
        ...state,
        error: null,
        isUpdating: true,
      }
    }

    case types.DELETING_LICENSE_USER_ERROR: {
      return {
        ...state,
        error: action.error,
        isUpdating: false,
      }
    }

    case types.DELETING_LICENSE_USER_SUCCESS: {
      const updatedUsers = state.license.users.filter(
        user =>
          user.licenseId === action.licenseId && action.email !== user.email,
      )
      return {
        ...state,
        license: {
          ...state.license,
          users: updatedUsers,
        },
        error: null,
        isUpdating: false,
      }
    }
    case types.GRANTING_NEW_ROLE_LICENSE_USER: {
      return {
        ...state,
        error: null,
        isUpdating: true,
      }
    }

    case types.GRANTING_NEW_ROLE_LICENSE_USER_ERROR: {
      return {
        ...state,
        isUpdating: false,
        error: action.error,
      }
    }

    case types.GRANTING_NEW_ROLE_LICENSE_USER_SUCCESS: {
      const users = state.license.users

      const updatedUsers = users.map(user =>
        user.email === action.email ? { ...user, roles: action.roles } : user,
      )
      return {
        ...state,
        license: {
          ...state.license,
          users: updatedUsers,
        },
        isUpdating: false,
      }
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/licenseManager/licenseManager.js